import Alpha from "./alpha.vue";

export default Alpha;
